import React from 'react';

class SubscribeToAlertsClientConfig extends React.Component {
  constructor(props) {
    super(props)
    this.searchUsers = this.searchUsers.bind(this);
    this.removeUser = this.removeUser.bind(this);
    this.addUser = this.addUser.bind(this);
    this.state = {
      subscribedUsers: this.props.subscribed_users,
      userSearchList: []
     };
  }

  removeUser(event) {
    var email = $(event.target.parentElement).text();
    if (email && email != "") {
      $.ajax({
        type: "POST",
        url: "/datapulse/alerts/unsubscribe-user/",
        async: false,
        data: {
          email: email,
          section_name: this.props.section_name,
          section_id: this.props.section_id
        },
        success: () => {
          let subscribedUsers = [...this.state.subscribedUsers];
          subscribedUsers.splice(subscribedUsers.findIndex((e) => { return e == email }), 1);
          this.setState({ subscribedUsers: subscribedUsers, userSearchList: [] });
          $("#userListSearch").val("");
        }
      })
    }
  }

  addUser(event) {
    var email = $(event.target).text();
    if (email && email != "") {
      $.ajax({
        type: "POST",
        url: "/datapulse/alerts/subscribe-user/",
        async: false,
        data: {
          email: email,
          section_name: this.props.section_name,
          section_id: this.props.section_id
        },
        success: (data) => {
          let subscribedUsers = [...this.state.subscribedUsers];
          subscribedUsers.push(data);
          this.setState({ subscribedUsers: subscribedUsers, userSearchList: [] });
          $("#userListSearch").val("");
        }
      })
    }
  }

  searchUsers(event) {
    var filter = event.target.value.trim();
    if (filter && filter != "") {
      $.ajax({
        type: "GET",
        url: "/datapulse/user-access/search-users/" + filter,
        dataType: 'json',
        contentType: "application/json",
        async: false,
        data: {
          section_name: this.props.section_name,
          section_id: this.props.section_id
        },
        success: (data) => {
          this.setState({ userSearchList: data });
        }
      })
    }
  }

  render() {
    let section = this.props.section_name.match(/[A-Z][a-z]+/g)[0];
    if (section == "Seo") {
      section = "SEO";
    }
    let users = this.state.subscribedUsers.map((userEmail, index) => {
      return (
        <li key={index}>
          <i className="fas fa-minus-circle" onClick={(e) => this.removeUser(e)}></i>
          <span>{userEmail}</span>
        </li>
      )
    });
    let userSearchList = this.state.userSearchList.map((userEmail, index) => {
      return (
        <a key={index} className="dropdown-item" onClick={(e) => this.addUser(e)}>
          <i className="fas fa-plus"></i>
          <span>{userEmail}</span>
        </a>
      )
    })

    return (
      <React.Fragment>
        <h5 className="mb-3">Subscribe to {section} Alerts</h5>
        <div className="dropdown">
          <input id="userListSearch" className="dropdown-toggle" data-toggle="dropdown" type="text" placeholder="Enter User's Email" onChange={(e) => this.searchUsers(e)} />
          <span className="focus-bg"></span>
          <div id="userListDropdown" className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            {userSearchList}
          </div>
        </div>
        <div className="subscribedUsersList mt-3">
          <ul style={{listStyleType: "none", paddingLeft: "0px"}}>
            {users}
          </ul>
        </div>
      </React.Fragment>
    )
  }
}

export default SubscribeToAlertsClientConfig;
